export default __webpack_public_path__ + "static/desktop_sek2_KV04-d9751a35c640175a91e11a35187d7003.mp4";